export default __webpack_public_path__ + "static/media/avatar-4.8bc41f8a.jpg";